import isNil from 'lodash/isNil';
import { STATES_US } from '../CommonConstants';

const INSIDE_US = 1;
const OUTSIDE_US = 2;

export const taxLocationGroups = [
  { groupId: INSIDE_US, title: 'United States' },
  { groupId: OUTSIDE_US, title: 'Outside the U.S.' },
];

export const taxLocations = STATES_US.filter(state => !isNil(state.taxID)).map(state => ({
  ...state,
  label: state.name,
  value: state.taxID,
  groupId: state.isInsideUS ? INSIDE_US : OUTSIDE_US,
}));
